"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.AccountTray = AccountTray;
exports.default = void 0;
var _propTypes = _interopRequireDefault(require("prop-types"));
var _react = _interopRequireWildcard(require("react"));
var _reactMintl = require("@godaddy/react-mintl");
var _headerUtil = require("@ux/header-util");
var _userCircle = _interopRequireDefault(require("@ux/icon/user-circle"));
var _link = _interopRequireDefault(require("@ux/link"));
var _trayMenu = require("@ux/tray-menu");
var _dropdownHeader = _interopRequireDefault(require("./dropdown-header"));
var _enums = require("./enums");
var _golfToEid = _interopRequireDefault(require("@gd-internal/golf-to-eid"));
var _links = _interopRequireDefault(require("./links"));
var _pro = _interopRequireDefault(require("./pro"));
var _userDetails = _interopRequireDefault(require("./user-details"));
require("@ux/tray-menu/styles");
function _interopRequireWildcard(e, t) { if ("function" == typeof WeakMap) var r = new WeakMap(), n = new WeakMap(); return (_interopRequireWildcard = function (e, t) { if (!t && e && e.__esModule) return e; var o, i, f = { __proto__: null, default: e }; if (null === e || "object" != typeof e && "function" != typeof e) return f; if (o = t ? n : r) { if (o.has(e)) return o.get(e); o.set(e, f); } for (const t in e) "default" !== t && {}.hasOwnProperty.call(e, t) && ((i = (o = Object.defineProperty) && Object.getOwnPropertyDescriptor(e, t)) && (i.get || i.set) ? o(f, t, i) : f[t] = e[t]); return f; })(e, t); }
/**
 * Render user dropdown menu.
 *
 * @Constructor
 * @function AccountTray
 * @api public
 * @param {props} props passed properties to function
 */
function AccountTray(props) {
  const {
    loggedIn
  } = props;
  const [isOpen, setIsOpen] = (0, _react.useState)(false);
  const status = loggedIn ? 'signout' : 'signin';
  const privateLabelId = props.privateLabelId;
  //
  // Generate Traffic2 eids to be used to track clicks. Map the generated
  // strings back to the same keys the Golf translations strings have.
  //

  const eids = (0, _react.useMemo)(() => {
    return Object.entries(_enums.golf).reduce((acc, [key, value]) => {
      acc[key] = (0, _golfToEid.default)(value, {
        prefix: `${props.eidPrefix}_account_tray`,
        postfix: 'link.click'
      });
      return acc;
    }, {});
  }, [props.eidPrefix]);
  let trayName = /*#__PURE__*/_react.default.createElement(_userCircle.default, null);
  if (privateLabelId === 1) {
    if (loggedIn) {
      // props.displayName is the short name (e.g. "Jane").
      trayName = /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, /*#__PURE__*/_react.default.createElement("span", {
        className: "desktop-account-tray-name"
      }, props.displayName), /*#__PURE__*/_react.default.createElement("span", {
        className: "mobile-account-tray-name"
      }, /*#__PURE__*/_react.default.createElement(_userCircle.default, null)));
    } else {
      trayName = /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, /*#__PURE__*/_react.default.createElement("span", {
        className: "desktop-account-tray-name"
      }, /*#__PURE__*/_react.default.createElement(_reactMintl.FormattedMessage, {
        id: _enums.golf.signin
      })), /*#__PURE__*/_react.default.createElement("span", {
        className: "mobile-account-tray-name"
      }, /*#__PURE__*/_react.default.createElement(_userCircle.default, null)));
    }
  }
  return /*#__PURE__*/_react.default.createElement("div", null, /*#__PURE__*/_react.default.createElement("div", {
    className: "tray-container"
  }, /*#__PURE__*/_react.default.createElement(_reactMintl.FormattedMessage, {
    id: props.preset === 'internal-header' ? _enums.golf.internalModeTitle : _enums.golf.title
  }, content => {
    var _props$bottomLinks, _props$urls;
    return /*#__PURE__*/_react.default.createElement(_trayMenu.TrayMenu, {
      ariaLabel: content,
      trayAlignment: "right",
      name: trayName,
      className: "customer-menu",
      showOpenCaret: true,
      traySpanClass: "tray-toggle-span",
      type: "base",
      fullwidth: false,
      onToggle: setIsOpen.bind(!isOpen),
      "data-eid": `${props.eidPrefix}_account_tray.button.click`
    }, /*#__PURE__*/_react.default.createElement("div", {
      className: "customer-info-wrap"
    }, /*#__PURE__*/_react.default.createElement("div", {
      className: "customer-name"
    }, /*#__PURE__*/_react.default.createElement(_dropdownHeader.default, {
      loggedIn: loggedIn,
      name: props.name,
      preset: props.preset
    })), /*#__PURE__*/_react.default.createElement("div", {
      className: "customer-details"
    }, /*#__PURE__*/_react.default.createElement(_userDetails.default, {
      loggedIn: loggedIn,
      urls: props.urls,
      name: props.name,
      shopperId: props.shopperId,
      vip: props.privateLabelId === 1 && props.vip,
      username: props.username,
      proshopper: props.proshopper,
      rewardPoints: props.rewardPoints,
      eids: eids,
      pcx: props.pcx
    }))), /*#__PURE__*/_react.default.createElement("div", {
      className: "tray-heading"
    }, /*#__PURE__*/_react.default.createElement(_reactMintl.FormattedMessage, {
      id: _enums.golf.account
    })), /*#__PURE__*/_react.default.createElement(_pro.default, {
      loggedIn: loggedIn,
      proshopper: props.proshopper,
      eids: eids,
      urls: props.urls,
      pcx: props.pcx
    }), /*#__PURE__*/_react.default.createElement(_links.default, {
      privateLabelType: props.privateLabelType,
      privateLabelId: props.privateLabelId,
      resellerUrls: props.resellerUrls,
      urls: props.urls,
      urlArgs: props.urlArgs,
      bottomLinks: (_props$bottomLinks = props === null || props === void 0 ? void 0 : props.bottomLinks) !== null && _props$bottomLinks !== void 0 ? _props$bottomLinks : [],
      eids: eids
    }), /*#__PURE__*/_react.default.createElement("div", {
      className: "tray-menu-divider"
    }), (props === null || props === void 0 ? void 0 : (_props$urls = props.urls) === null || _props$urls === void 0 ? void 0 : _props$urls.sso) && /*#__PURE__*/_react.default.createElement(_link.default, {
      className: "customer-link login",
      href: _headerUtil.url.updateQuery(props.urls.sso[status === 'signin' ? 'login' : 'logout'].href, props.sso),
      "data-eid": eids[status]
    }, /*#__PURE__*/_react.default.createElement(_reactMintl.FormattedMessage, {
      id: _enums.golf[status]
    })));
  })), isOpen && /*#__PURE__*/_react.default.createElement("div", {
    className: "account-tray-menu-bg"
  }));
}
AccountTray.propTypes = {
  bottomLinks: _propTypes.default.array,
  displayName: _propTypes.default.string,
  eidPrefix: _propTypes.default.string,
  loggedIn: _propTypes.default.bool,
  name: _propTypes.default.string,
  preset: _propTypes.default.string,
  privateLabelId: _propTypes.default.number,
  privateLabelType: _propTypes.default.number,
  proshopper: _propTypes.default.bool,
  resellerUrls: _propTypes.default.object,
  rewardPoints: _propTypes.default.number,
  shopperId: _propTypes.default.string,
  sso: _propTypes.default.object,
  username: _propTypes.default.string,
  urls: _propTypes.default.object.isRequired,
  urlArgs: _propTypes.default.object,
  vip: _propTypes.default.object,
  pcx: _propTypes.default.bool
};
var _default = exports.default = AccountTray;